import React, { Component } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Paper,
  Grid
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import cartStyles from '../cart.module.css';
import commonStyles from '../../common/common.module.css';
import MaterialTable from 'material-table';
import Zoom from '@material-ui/core/Zoom';
import PaymentDetailsAwbs from '../../../models/PaymentDetailsAwbs';
import PaymentDetailsAwbsServices from '../../../models/PaymentDetailsAwbsServices';
import { getAdditionalServiceDetails, getAdditionalServiceName } from '../../../utils/additionalServices';
import { formatCurrency } from '../../../utils/currencyFormatter';
import { connect } from 'react-redux';
import paymentRemote from '../../../api/paymentsRemote';
import { receiveError } from '../../../store/actions/notificationAction';
import ResponseError from '../../../models/ResponseError';
import ApiResponse from '../../../models/ApiResponse';
import PaymentDetailsHistoryAwbs from '../../../models/PaymentHistory';
import moment from 'moment';

const styles = (theme: Theme) =>
  createStyles({
    rowContainer: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    button: {
      width: '100%',
      height: '34px',
      textTransform: 'none',
    },
    materialIcon: {
      margin: '10px 3px 0',
      fontSize: 20,
      '&:hover': {
        cursor: 'pointer',
      },
    },
  });

interface PaymentHistoryProps {
  classes: any;
  code: string;
  number: string;
  modalOpen: boolean;
  handleClose: (type: string) => void;
  receiveError: Function;
}

interface PaymentHistoryState {
  paymentHistory: Array<PaymentDetailsHistoryAwbs>;
}


class PaymentHistory extends Component<PaymentHistoryProps, PaymentHistoryState> {

  state: PaymentHistoryState = {
    paymentHistory: []
  }

  componentDidMount() {
    paymentRemote.getPaymentHistory(this.props.code, this.props.number).then((resp: ApiResponse<Array<PaymentDetailsHistoryAwbs>>) => {

      const payment: Array<PaymentDetailsHistoryAwbs> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (payment) {
        this.setState({
          paymentHistory: payment
        });
      }
    
      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  render() {
    const paymentTable = this.state.paymentHistory.map((pay: any) => {
      return (
        <div className={ `${cartStyles.wrapper}` }>

          <h3 className={ `${cartStyles.header}` }> { pay.order_number } </h3>
          <div className={ cartStyles.orderDetails }>
          <span>Created Date: { moment(pay.pickup_date).format("DDMMMYY") }</span> <span>Delivered Date: { pay.delivered_date ? moment(pay.delivered_date).format("DD MMM YY") : '-' }</span>
          </div>
          <MaterialTable

            components={{ Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/> }}

            columns={[
              {
                title: 'AirwayBill', field: '', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                render: (rowData: PaymentDetailsAwbs) => {
                  return (<span>{ rowData.awb_code}-{rowData.awb_number }</span>)
                }
              },
              {
                title: 'Fee', field: '', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                render: (rowData: PaymentDetailsAwbs) => {

                  const fees: Array<JSX.Element> = rowData.services.map((service: PaymentDetailsAwbsServices, index: number) => (
                    <div key={ index } className={ cartStyles.feeName }>
                      { getAdditionalServiceName(service.type) }:
                      { service.type === 'other' || service.type === 'gha_adjust' ? ' ' + service.params.reason : '' }
                    </div>
                  ));

                  return <div>{ fees }</div>;
                }
              },
              {
                title: 'Details', field: 'details', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                render: (rowData: PaymentDetailsAwbs) => {

                  const dues: Array<JSX.Element> = rowData.services.map((service: PaymentDetailsAwbsServices, index: number) => (
                    <div key={ index } className={ cartStyles.dueRow} >
                      <div>{ getAdditionalServiceDetails(service, 20) }</div>
                    </div>
                  ));

                  return <div>{dues}</div>;
                }
              },
              {
                title: 'Amount', field: '', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                render: (rowData: PaymentDetailsAwbs) => {

                  const amount: Array<JSX.Element> = rowData.services.map((service: PaymentDetailsAwbsServices, index: number) => (
                    <div key={ index } className={ cartStyles.dueRow }>
                      <div>$</div>
                      <div>{ formatCurrency(service.amount, 2,) }</div>
                    </div>
                  ));

                  return (
                    <div>
                      { amount }
                      <div className={ `${cartStyles.dueRow} ${cartStyles.dueSumRow}` }>
                        <div>$</div>
                        <div>{ formatCurrency(rowData.total_amount, 2,) }</div>
                      </div>
                    </div>
                  )
                }
              }
            ]}

            data={ pay.awbs }

            options={{
              paging: false,
              showTitle: false,
              toolbar: false,
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 2,
              }
            }}
          />
        </div>
      )
    }) 


    return (
      <Dialog
        open={ this.props.modalOpen }
        onClose={ () => this.props.handleClose('history') }
        aria-labelledby='form-dialog-title'
        maxWidth={'sm'}
        fullWidth={ true }
        TransitionComponent={ Zoom }
        transitionDuration={ 500 }>
        <DialogTitle id='form-dialog-title'>
          <div className={ cartStyles.dialogTitle }>
            <span className={ cartStyles.name }> Payment History</span>
            <IconButton
              aria-label='Close'
              className={ cartStyles.close }
              onClick={ () => this.props.handleClose('history') }>
              <CloseIcon color='primary' />
            </IconButton>
          </div>
          <hr />
        </DialogTitle>
        <DialogContent>
          <div style={{ paddingTop: 10 }}>
            <Grid container>

            </Grid>

          </div>
          { paymentTable }

        </DialogContent>
      </Dialog>
    );
  }

};
const mapStateToProps = (state: any) => {
  return {
    cart: state.cart,
    additionalService: state.additionalService
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PaymentHistory));
